module.exports = __webpack_public_path__ + "img/Veranza-19-min.98d9a40f.jpg";